// ReplyWindowField.tsx · v12.10.31 (#2287 #2292 ONE Reply window - a number + hours / minutes, minimum 5 minutes, no 0, default 30 hours,
// at most 168 hours; the same value on Call Handling › Texts on calls and Settings › Text Messaging) · 2026-11-05 · VoiceSpectrum AI
import { useEffect, useState } from 'react';

export const REPLY_WINDOW_MIN_MINUTES = 5;
export const REPLY_WINDOW_MAX_MINUTES = 168 * 60;
export const REPLY_WINDOW_DEFAULT_MINUTES = 30 * 60;

/** minutes -> the unit it reads best in (whole hours -> hours). */
export function splitMinutes(m: number): { value: number; unit: 'hours' | 'minutes' } {
  return m % 60 === 0 ? { value: m / 60, unit: 'hours' } : { value: m, unit: 'minutes' };
}
export function windowLabel(m: number): string {
  const s = splitMinutes(m);
  return `${s.value} ${s.unit === 'hours' ? (s.value === 1 ? 'hour' : 'hours') : (s.value === 1 ? 'minute' : 'minutes')}`;
}

export default function ReplyWindowField({ minutes, onChange, disabled, title }: {
  minutes: number; onChange: (m: number) => void; disabled?: boolean; title?: string;
}) {
  const init = splitMinutes(minutes || REPLY_WINDOW_DEFAULT_MINUTES);
  const [unit, setUnit] = useState<'hours' | 'minutes'>(init.unit);
  const [text, setText] = useState(String(init.value));
  // re-sync only when the value changes from outside (Discard, the other page's save) - not while typing
  useEffect(() => {
    const cur = unit === 'hours' ? Number(text) * 60 : Number(text);
    if (cur === minutes) return;
    const s = splitMinutes(minutes || REPLY_WINDOW_DEFAULT_MINUTES);
    setUnit(s.unit); setText(String(s.value));
  }, [minutes]); // eslint-disable-line react-hooks/exhaustive-deps
  const n = Number(text);
  const asMin = unit === 'hours' ? n * 60 : n;
  const err = !text.trim() || !Number.isFinite(n) || n <= 0 ? '0 is not a valid window'
    : asMin < REPLY_WINDOW_MIN_MINUTES ? 'At least 5 minutes'
    : asMin > REPLY_WINDOW_MAX_MINUTES ? 'At most 168 hours' : '';
  const commit = (t: string, u: 'hours' | 'minutes') => {
    const v = Math.round(Number(t));
    const m = u === 'hours' ? v * 60 : v;
    if (Number.isFinite(v) && v > 0 && m >= REPLY_WINDOW_MIN_MINUTES && m <= REPLY_WINDOW_MAX_MINUTES) onChange(m);
  };
  return (
    <div className="tx-num" title={title} style={disabled ? { opacity: 0.5 } : undefined}>
      <input type="number" min={1} value={text} disabled={disabled} aria-label="Reply window" aria-invalid={!!err}
        style={err ? { borderColor: '#dc2626' } : undefined}
        onChange={(e) => { setText(e.target.value); commit(e.target.value, unit); }} />
      <select value={unit} disabled={disabled} aria-label="Reply window unit"
        onChange={(e) => { const u = e.target.value as 'hours' | 'minutes'; setUnit(u); commit(text, u); }}>
        <option value="hours">hours</option>
        <option value="minutes">minutes</option>
      </select>
      <span className="tx-default">{err || 'min 5 minutes · max 168 hours'}</span>
    </div>
  );
}
